(function () {
    'use strict';

    angular.module('imApp').factory('acCustTransesService', [
        '$ihttp',
        function ($ihttp) {
            var service = {
                getAcCustTranses: function (parms) {
                    return $ihttp.post({
                        method: 2794,
                        parameters: parms || {},
                    });
                },
                removeMatching: function (setting) {
                    return $ihttp.post({
                        method: 2821,
                        parameters: setting,
                    });
                },
                matchSelected: function (mergeObj) {
                    return $ihttp.post({
                        method: 2822,
                        parameters: mergeObj,
                    });
                },
                matchAuto: function (setting) {
                    return $ihttp.post({
                        method: 2823,
                        parameters: setting,
                    });
                },
                searchAccountInfo: function (params) {
                    return $ihttp.post({
                        method: 2090,
                        parameters: params,
                    });
                },
            };

            return service;
        },
    ]);
})();
